/**
 * @generated SignedSource<<fb2f30ac3ccf423047189eaaf1d2906e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeletePlaceholderAllocationInput = {
  id?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deletePlaceholderAllocationMutation$variables = {
  input: DeletePlaceholderAllocationInput;
};
export type deletePlaceholderAllocationMutation$data = {
  readonly deletePlaceholderAllocation: {
    readonly deletedAllocationId: string | null;
  } | null;
};
export type deletePlaceholderAllocationMutation = {
  variables: deletePlaceholderAllocationMutation$variables;
  response: deletePlaceholderAllocationMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeletePlaceholderAllocationPayload",
    "kind": "LinkedField",
    "name": "deletePlaceholderAllocation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedAllocationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deletePlaceholderAllocationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deletePlaceholderAllocationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4aac44752774fcbb62e97e7b039c2f8b",
    "id": null,
    "metadata": {},
    "name": "deletePlaceholderAllocationMutation",
    "operationKind": "mutation",
    "text": "mutation deletePlaceholderAllocationMutation(\n  $input: DeletePlaceholderAllocationInput!\n) {\n  deletePlaceholderAllocation(input: $input) {\n    deletedAllocationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "f405f4978fc7be01e5e0ccca2eb35099";

export default node;
